import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  toggle() {
    this.submitTarget.disabled = !this.inputTarget.value
  }
}
